export default "__VITE_ASSET__9roYs0Sm__"